const galleryCDNUrl = 'https://media.umangapp.in/cdn/landing/gallery';

export const awardsGallery: any[] = [
  {
    image: `${galleryCDNUrl}/20.jpg`,
    imageWebp: `${galleryCDNUrl}/20.webp`,
  },
  {
    image: `${galleryCDNUrl}/19.jpg`,
    imageWebp: `${galleryCDNUrl}/19.webp`,
  },
  {
    image: `${galleryCDNUrl}/18.jpg`,
    imageWebp: `${galleryCDNUrl}/18.webp`,
  },
  {
    image: `${galleryCDNUrl}/1.jpg`,
    imageWebp: `${galleryCDNUrl}/1.webp`,
  },
  {
    image: `${galleryCDNUrl}/2.jpg`,
    imageWebp: `${galleryCDNUrl}/2.webp`,
  },
  {
    image: `${galleryCDNUrl}/3.jpg`,
    imageWebp: `${galleryCDNUrl}/3.webp`,
  },
  {
    image: `${galleryCDNUrl}/4.jpg`,
    imageWebp: `${galleryCDNUrl}/4.webp`,
  },
];

export const workshopsGallery: any[] = [

  {
    image: `${galleryCDNUrl}/16.jpg`,
    imageWebp: `${galleryCDNUrl}/16.webp`,
  },
  {
    image: `${galleryCDNUrl}/17.jpg`,
    imageWebp: `${galleryCDNUrl}/17.webp`,
  },
  {
    image: `${galleryCDNUrl}/5.jpg`,
    imageWebp: `${galleryCDNUrl}/5.webp`,
  },
  {
    image: `${galleryCDNUrl}/6.jpg`,
    imageWebp: `${galleryCDNUrl}/6.webp`,
  },
  // {
  //   image: `${galleryCDNUrl}/7.jpg`,
  //   imageWebp: `${galleryCDNUrl}/7.webp`,
  // },
  {
    image: `${galleryCDNUrl}/8.jpg`,
    imageWebp: `${galleryCDNUrl}/8.webp`,
  },
  // {
  //   image: `${galleryCDNUrl}/9.jpg`,
  //   imageWebp: `${galleryCDNUrl}/9.webp`,
  // },
  {
    image: `${galleryCDNUrl}/10.jpg`,
    imageWebp: `${galleryCDNUrl}/10.webp`,
  },
  // {
  //   image: `${galleryCDNUrl}/11.jpg`,
  //   imageWebp: `${galleryCDNUrl}/11.webp`,
  // },
  // {
  //   image: `${galleryCDNUrl}/12.jpg`,
  //   imageWebp: `${galleryCDNUrl}/12.webp`,
  // },
  // {
  //   image: `${galleryCDNUrl}/13.jpg`,
  //   imageWebp: `${galleryCDNUrl}/13.webp`,
  // },
  {
    image: `${galleryCDNUrl}/14.jpg`,
    imageWebp: `${galleryCDNUrl}/14.webp`,
  },
  {
    image: `${galleryCDNUrl}/15.jpg`,
    imageWebp: `${galleryCDNUrl}/15.webp`,
  }
];

export const videoGallery: any[] = [
  {
    video: 'https://www.youtube.com/embed/Jm7E5lC8sg8?si=XyVbvQVbttbfVJCz',
  },
  {
    video: 'https://www.youtube.com/embed/k79qOiZ42C4?si=N-jSW4FMGfoC4xCo',
  },
];